import React from 'react';
import { Music2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-blue px-4 py-24 text-center text-white" data-id="element-60" data-mp="3n4wdgbtdixoq">
      <Reveal className="mx-auto max-w-3xl" data-id="element-61" data-mp="3s2xu6q3bukx1">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-white/15 text-brand-orange" data-id="element-62" data-mp="vlb25ivvxeh">
          <Music2Icon className="h-7 w-7" aria-hidden="true" data-id="element-63" data-mp="2zea66mr71hfs" />
        </div>
        <h2 className="mt-5 text-4xl font-black md:text-5xl" data-id="element-64" data-mp="34cbvvqj4kf08">
          ¿Listo para Llevar Música a Cada Aula?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-65" data-mp="39an8g90t13m5">
          Sumate a los docentes que ya organizaron su año con Música Lista.
        </p>
        <CTAButton className="mt-9 px-10 py-5 text-lg" data-id="element-66" data-mp="2gn0se1ae46ie">QUIERO EL PACK MÚSICA LISTA</CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-67" data-mp="2lm3zdr9xkmt0">
          Acceso inmediato · Pago único · Garantía de 7 días
        </p>
      </Reveal>
    </section>;
}